import * as actionTypes from '../Actions/ActionTypes'

const initialState = {
  cities: [],
}

const getCitiesSuccess = (state, action) => {
  let { cities } = action.payload

  return {
    ...state,
    cities,
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CITIES_SUCCESS:
      return getCitiesSuccess(state, action)

    default:
      return state
  }
}

export default reducer
